import Fetch, { V1 } from 'Util/fetcher';

const INITIAL_STATE = {
  stockIpoLoading: null,
  stockIpoData: null,
  stockIpoError: null,

  stockIpoDetailLoading: false,
  stockIpoDetailData: null,
  stockIpoDetailError: null,
};

const ON_REQUEST_STOCK_IPO = 'ON_REQUEST_STOCK_IPO';
const ON_REQUEST_STOCK_IPO_FAILURE = 'ON_REQUEST_STOCK_IPO_FAILURE';
const ON_REQUEST_STOCK_IPO_SUCCESS = 'ON_REQUEST_STOCK_IPO_SUCCESS';

const ON_REQUEST_STOCK_IPO_DETAIL = 'ON_REQUEST_STOCK_IPO_DETAIL';
const ON_REQUEST_STOCK_IPO_DETAIL_FAILURE = 'ON_REQUEST_STOCK_IPO_DETAIL_FAILURE';
const ON_REQUEST_STOCK_IPO_DETAIL_SUCCESS = 'ON_REQUEST_STOCK_IPO_DETAIL_SUCCESS';

function onRequestStockIpo(payload) { 
  return {
    type: ON_REQUEST_STOCK_IPO,
    payload
  };
}

function onRequestStockIpoSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_IPO_SUCCESS,
    payload,
  };
}

function onRequestStockIpoFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_IPO_FAILURE,
    payload,
  };
}

function onRequestStockIpoDetail() {
  return {
    type: ON_REQUEST_STOCK_IPO_DETAIL,
  };
}
function onRequestStockIpoDetailSuccess(payload) {
  return {
    type: ON_REQUEST_STOCK_IPO_DETAIL_SUCCESS,
    payload,
  };
}
function onRequestStockIpoDetailFailure(payload) {
  return {
    type: ON_REQUEST_STOCK_IPO_DETAIL_FAILURE,
    payload,
  };
}

export const onDoRequestStockIpo = () => (dispatch) => {
  dispatch(onRequestStockIpo());
  Fetch.get(`${V1}e-ipo/discovery/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestStockIpoSuccess(resp.json));
      } else {
        dispatch(onRequestStockIpoFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestStockIpoFailure(error.message));
    });
};

export const onDoRequestStockIpoDetail = code => (dispatch) => {
  dispatch(onRequestStockIpoDetail());
  Fetch.get(`${V1}stock/data/e-ipo/detail/${code}/`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestStockIpoDetailSuccess(resp.json));
    } else {
      dispatch(onRequestStockIpoDetailFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestStockIpoDetailFailure(error.message));
  });
};

const stockIpo = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case ON_REQUEST_STOCK_IPO:
      return {
        ...state,
        stockIpoLoading: {
          ...state.stockIpoLoading,
        },
      };
      case ON_REQUEST_STOCK_IPO_SUCCESS:
      return {
        ...state,
        stockIpoLoading: true,
        stockIpoData: action.payload,
        stockIpoFailure: null,
      };
      case ON_REQUEST_STOCK_IPO_FAILURE:
        return {
          ...state,
          stockIpoLoading: true,
          stockIpoData: null,
          stockIpoFailure: action.payload,
        };
      case ON_REQUEST_STOCK_IPO_DETAIL:
        return {
          ...state,
          stockIpoDetailLoading: true,
          stockIpoDetailError: null
        };
      case ON_REQUEST_STOCK_IPO_DETAIL_SUCCESS:
        return {
          ...state,
          stockIpoDetailLoading: false,
          stockIpoDetailData: action.payload,
          stockIpoDetailError: null
        };
      case ON_REQUEST_STOCK_IPO_DETAIL_FAILURE:
        return {
          ...state,
          stockIpoDetailLoading: false,
          stockIpoDetailError: action.payload
        };
      default: 
        return state;
  }
};

export default stockIpo;
